<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4">
      <path stroke-linejoin="round" d="M24 29L12 17h8V6h8v11h8z" clip-rule="evenodd" />
      <path d="M42 37H6m28 7H14" />
    </g>
  </svg>
</template>
